export const LOGIN_USER_START = "LOGIN_USER_START";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const SHOW_LOGIN_ERROR = "SHOW_LOGIN_ERROR";
export const HIDE_LOGIN_ERROR = "HIDE_LOGIN_ERROR";
export const CREATE_ACCOUNT_FAILURE = "CREATE_ACCOUNT_FAILURE";
export const CREATE_ACCOUNT_START = "CREATE_ACCOUNT_START";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const CHECK_AUTH_START = "CHECK_AUTH_START";
export const CHECK_AUTH_SUCCESS = "CHECK_AUTH_SUCCESS";
export const SHOW_LOGIN_PAGE = "SHOW_LOGIN_PAGE";
export const SET_IS_FIRST_TIME = "SET_IS_FIRST_TIME";
export const SET_IS_WELCOME = "SET_IS_WELCOME";
export const CLEAN_LOCAL_STORAGE = "CLEAN_LOCAL_STORAGE";
export const PASSWORD_RESET_START = "PASSWORD_RESET_START";
export const PASSWORD_RESET_FAILURE = "PASSWORD_RESET_FAILURE";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const PASSWORD_VALIDATE_START = "PASSWORD_VALIDATE_START";
export const PASSWORD_VALIDATE_SUCCESS = "PASSWORD_VALIDATE_SUCCESS";
export const PASSWORD_VALIDATE_FAILURE = "PASSWORD_VALIDATE_FAILURE";
export const UPDATE_PASSWORD_AUTH_START = "UPDATE_PASSWORD_AUTH_START";
export const CLEAR_PASS_MESSAGES = "CLEAR_PASS_MESSAGES";
export const UPDATE_PASSWORD_AUTH_SUCCESS = "UPDATE_PASSWORD_AUTH_SUCCESS";
export const UPDATE_PASSWORD_AUTH_FAILURE = "UPDATE_PASSWORD_AUTH_FAILURE";
export const TOGGLE_REMEMBER_ME = "TOGGLE_REMEMBER_ME";
export const RESET_REGISTRATION_FAILED_MEESAGE =
  "RESET_REGISTRATION_FAILED_MEESAGE";
export const CANCEL_ACCOUNT_SUCCESS = "CANCEL_ACCOUNT_SUCCESS";
export const START_REDIRECT = "START_REDIRECT";
export const PNS_DOWN = "PNS_DOWN";
export const FETCH_ALL_CLIENTS_VERSION_START =
  "FETCH_ALL_CLIENTS_VERSION_START";
export const FETCH_ALL_CLIENTS_VERSION_SUCCESS =
  "FETCH_ALL_CLIENTS_VERSION_SUCCESS";
export const UPDATE_CLIENT_VERSION_START = "UPDATE_CLIENT_VERSION_START";
export const ADD_CLIENT_VERSION_START = "ADD_CLIENT_VERSION_START";
export const CREATE_SUB_USER_START = "CREATE_SUB_USER_START";
export const VALIDATE_SUB_USER_START = "VALIDATE_SUB_USER_START";
export const VALIDATE_SUB_USER_SUCCESS = "VALIDATE_SUB_USER_SUCCESS";
export const VALIDATE_SUB_USER_FAILURE = "VALIDATE_SUB_USER_FAILURE";
// export const CREATE_SUB_USER_SUCCESS = "CREATE_SUB_USER_SUCCESS";
export const FETCH_PROMO_DISCOUNT_START = "FETCH_PROMO_DISCOUNT_START";
export const FETCH_PROMO_DISCOUNT_SUCCESS = "FETCH_PROMO_DISCOUNT_SUCCESS";
export const FETCH_PROMO_DISCOUNT_FAILURE = "FETCH_PROMO_DISCOUNT_FAILURE";
export const CREATE_PROMO_ACCOUNT_START = "CREATE_PROMO_ACCOUNT_START";
export const VALIDATE_360_START = "VALIDATE_360_START";
export const VALIDATE_360_FAILURE = "VALIDATE_360_FAILURE";
export const VALIDATE_IBACKUP_START = "VALIDATE_IBACKUP_START";
export const VALIDATE_IBACKUP_FAILURE = "VALIDATE_IBACKUP_FAILURE";
